import { GoogleLogin } from '@react-oauth/google';
import googleAuthImg from 'assets/icons/google_signin.png';
import { Button } from 'components/atoms/Button';
import { useEffect, useState, type FC } from 'react';
import ResizeObserver from 'resizeObserver';
import { logAmplitude } from 'utils/amplitude';

const GoogleAuthButton: FC<{
  containerRef?: any;
  onSuccess: any;
  label?: string;
  tracingEvent: string;
}> = ({ containerRef, onSuccess, label, tracingEvent }) => {
  const [containerWidth, setContainerWidth] = useState(100);

  useEffect(() => {
    if (!containerRef.current) return;
    const resizeObserver = new ResizeObserver((d) => {
      const { contentRect } = d[0] || {};

      setContainerWidth(contentRect?.width);
    });

    resizeObserver.observe(containerRef.current);

    return () => resizeObserver.disconnect();
  }, [containerRef]);

  return (
    <Button
      structure="light"
      className="relative mb-2 flex items-center justify-center bg-white border border-primary-100 rounded-full h-12 w-full hover:bg-gray-50 transition-colors"
    >
      <div className="w-[20px] ml-[10px]">
        <img src={googleAuthImg} />
      </div>

      <p className="text-primary-700 font-semibold pl-1">
        {label || 'Sign in with Google'}
      </p>

      <div className="absolute left-0 right-0 flex justify-center opacity-0">
        <GoogleLogin
          shape="circle"
          onSuccess={(credentials) => {
            logAmplitude(tracingEvent);

            onSuccess(credentials);
          }}
          width={String(containerWidth)}
          useOneTap
        />
      </div>
    </Button>
  );
};

export default GoogleAuthButton;
